module.exports = __webpack_public_path__ + "media/assets/images/flags/hn-37a8626424c2bc66f74ff392c36d8edb.svg";